module.exports = __webpack_public_path__ + "img/loading2.8a2d5d6b.gif";